function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import JSZip from 'jszip';
import { configure } from 'safe-stable-stringify';
// List of paths to ignore
// '' represents the root object
// * represents a wildcard key
export var DEFAULT_PATH_IGNORE_LIST = [['api'], ['client'], ['dashboardData', '*', 'connection'], ['dashboardData', '*', 'sessionWrapper'], ['dashboardData', '*', 'openedMap'], ['layoutStorage'], ['storage']];

// The default maximum depth to serialize to in the redux data
var DEFAULT_MAXIMUM_DEPTH = 10;
function stringifyReplacer(ignoreList) {
  // modified from:
  // https://stackoverflow.com/questions/61681176/json-stringify-replacer-how-to-get-full-path
  var pathMap = new Map();
  // replacer function is also called for the initial object, key is ""
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/JSON/stringify#the_replacer_parameter

  return function replacer(key, value) {
    var _pathMap$get;
    // get and store path
    var currPath = [...((_pathMap$get = pathMap.get(this)) !== null && _pathMap$get !== void 0 ? _pathMap$get : []), key];
    if (value === Object(value)) pathMap.set(value, [...currPath]);
    currPath.shift();

    // check ignore list
    if (isOnIgnoreList(currPath, ignoreList)) {
      return undefined;
    }
    if (value instanceof Map) {
      return Array.from(value.entries());
    }

    // not in ignore list, return value
    return value;
  };
}
function isOnIgnoreList(currPath, ignoreList) {
  var _loop = function _loop(i) {
      if (currPath.length === ignoreList[i].length && currPath.every((v, index) => ignoreList[i][index] === '*' || v === ignoreList[i][index])) {
        // ignore list match
        return {
          v: true
        };
      }
    },
    _ret;
  for (var i = 0; i < ignoreList.length; i += 1) {
    _ret = _loop(i);
    if (_ret) return _ret.v;
  }
  return false;
}
export function getReduxDataString(reduxData) {
  var _stringify;
  var ignoreList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var maximumDepth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_MAXIMUM_DEPTH;
  // Limit the maximum depth to prevent linked structures from blowing up the log size
  // All objects at the maximum depth are replaced with "[Object]" or "[Array]"
  var stringify = configure({
    maximumDepth
  });
  return (// Using safe-stable-stringify which handles circular references and BigInt
    // All circular references are replaced with "[Circular]", and BigInt values are converted to a number
    (_stringify = stringify(reduxData, stringifyReplacer(ignoreList), 2 // Indent w/ 2 spaces
    )) !== null && _stringify !== void 0 ? _stringify : ''
  );
}
function getFormattedMetadata(metadata) {
  return JSON.stringify(metadata, null, 2);
}

/** Format a date to a string that can be used as a file name
 * @param date Date to format
 * @returns A string formatted as YYYY-MM-DD-HHMMSS
 */
function formatDate(date) {
  var year = date.getFullYear();
  var month = String(date.getMonth() + 1).padStart(2, '0');
  var day = String(date.getDate()).padStart(2, '0');
  var h = String(date.getHours()).padStart(2, '0');
  var m = String(date.getMinutes()).padStart(2, '0');
  var s = String(date.getSeconds()).padStart(2, '0');
  return "".concat(year, "-").concat(month, "-").concat(day, "-").concat(h).concat(m).concat(s);
}

/**
 * Export support logs with the given name.
 * @param logHistory Log history to include in the console.txt file
 * @param metadata Additional metadata to include in the metadata.json file
 * @param reduxData Redux data to include in the redux.json file
 * @param ignoreList List of JSON paths to ignore in redux data. A JSON path is a list representing the path to that value (e.g. client.data would be `['client', 'data']`). Wildcards (*) are accepted in the path.
 * @param fileNamePrefix The zip file name without the .zip extension. Ex: test will be saved as test.zip
 * @param maximumDepth The maximum depth to serialize the redux data to. Objects at the maximum depth will be replaced with "[Object]" or "[Array]".
 * @returns A promise that resolves successfully if the log archive is created and downloaded successfully, rejected if there's an error
 */
export function exportLogs(_x, _x2, _x3) {
  return _exportLogs.apply(this, arguments);
}
function _exportLogs() {
  _exportLogs = _asyncToGenerator(function* (logHistory, metadata, reduxData) {
    var ignoreList = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : DEFAULT_PATH_IGNORE_LIST;
    var fileNamePrefix = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "".concat(formatDate(new Date()), "_support_logs");
    var maximumDepth = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : DEFAULT_MAXIMUM_DEPTH;
    var zip = new JSZip();
    var folder = zip.folder(fileNamePrefix);
    folder.file('console.txt', logHistory.getFormattedHistory());
    if (metadata != null) {
      folder.file('metadata.json', getFormattedMetadata(metadata));
    }
    if (reduxData != null) {
      folder.file('redux.json', getReduxDataString(reduxData, ignoreList, maximumDepth));
    }
    var blob = yield zip.generateAsync({
      type: 'blob'
    });
    var link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = "".concat(fileNamePrefix, ".zip");
    link.click();
  });
  return _exportLogs.apply(this, arguments);
}
//# sourceMappingURL=LogExport.js.map